"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asPowerBI = void 0;
const tslib_1 = require("tslib");
function asPowerBI() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        throw new Error('Function not implemented.');
    });
}
exports.asPowerBI = asPowerBI;
//# sourceMappingURL=index.js.map